import * as React from 'react';

import { IconButton } from '@mui/material';

import { uiIconButtonSx } from '../config';

import type { IconButtonProps } from '@mui/material/IconButton';
import type { SxProps, Theme } from '@mui/material/styles';

type Props = Omit<IconButtonProps, 'component' | 'href' | 'target' | 'rel'> & {
	href?: string;
	target?: React.HTMLAttributeAnchorTarget;
	rel?: string;
};

export default function CustomIconButton({ href, target, rel, sx, ...props }: Props) {
	let sxArray: SxProps<Theme>[];
	if (Array.isArray(sx)) {
		sxArray = sx as SxProps<Theme>[];
	} else if (sx) {
		sxArray = [sx];
	} else {
		sxArray = [];
	}

	const button = href ? (
		<IconButton
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			{...(props as any)}
			component="a"
			href={href}
			target={target}
			rel={rel ?? (target === '_blank' ? 'noreferrer noopener' : undefined)}
			sx={[uiIconButtonSx.base, ...sxArray] as SxProps<Theme>}
		/>
	) : (
		<IconButton {...props} sx={[uiIconButtonSx.base, ...sxArray] as SxProps<Theme>} />
	);

	return button;
}
